export const PATH_SERVER = "/server"
export const PATH_REPORT = "/report"
